import Footer_img from "../assets/images/footerv1.png"

export const Footer = () =>  {
    return (
    
    <p className="footer-element">designed with love by Alexis Huang</p>
    )
}